import { GetEmployeeAccessDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useEmployeeAccess = (employeeId?: string) => {
  const { data, loading } = useQuery(GetEmployeeAccessDocument, {
    variables: { employeeId: employeeId! },
    skip: !employeeId,
  })
  return {
    loading,
    accessId: data?.employees.employee?.access?.id,
  }
}
